// extracted by mini-css-extract-plugin
export default {"list":"InspirationNavBar_list__94vdn","item":"InspirationNavBar_item__6p6mm","active":"InspirationNavBar_active__z3orJ"};